const actions = {
    SET_STATE: 'header/SET_STATE',
    SET_DATA: 'header/SET_DATA'
};

export default actions
